// src/belediye/pages/gorevler/TaleplerPage.js
//
// FAZ-91 — TALEPLER KAPISI.
//
// İKİ SAYFAYI BİRLEŞTİRMEZ; hangisinin çizileceğini seçer. Birleştirmek
// FAZ-56'nın kararını geri alırdı: "kapsam sekmeden değil SAYFADAN gelir."
// İki sayfanın rotası, izni, backend kapsamı, satır aksiyonları ve ek çipleri
// AYRI — tek bileşende toplamak kapsam sızması riski üretir.
//
// Taraf seçimi çip şeridine KONMAZ (§2.2): şerit "bunlar aynı listenin
// süzgeçleridir" sözleşmesini taşır, oysa bunlar ayrı sayfalar. Seçici
// navbarın ORTA yuvasında (FAZ-88'de kurulan yuva).

import React from "react";
import usePermissions from "../../hooks/usePermissions";
import useKatman from "../../hooks/useKatman";
import GorevAtaPage from "./GorevAtaPage";
import GorevlerimPage from "./GorevlerimPage";
import { useTarafSecimi } from "./tarafSecimi";
import "./TaleplerPage.css";

export default function TaleplerPage() {
  const { can } = usePermissions();
  const katmanAdi = useKatman();

  // Kural izinden türer, rol string'inden DEĞİL (K-7).
  // tasks.view_all hiçbir role verilmiyor (constants.py:152 — "görevler
  // tamamen kişiseldir"), bu yüzden ayrım tam iki izinle netleşiyor.
  const verir = can("tasks.view_created");
  const alir = can("tasks.view_assigned") || can("tasks.view_unit_pool");
  const cift = verir && alir;

  const { taraf, setTaraf, secilebilir } = useTarafSecimi({
    cift,
    verir,
    alir,
  });

  /* FAZ-92 — NAVBAR SEÇİCİSİ KALDIRILDI.
     Kullanıcı (2026-08-01): "hem talep atan hem talep alan kişilerde
     yukarıda yaptığın başlık kısmındaki yapı olmasın; bana mantıklı gelen,
     oraya tıklanınca her seferinde 'hangi sayfaya geçmek istiyorsun'
     sorulsun."
     Yani seçim ÜST barda kalıcı bir seçici değil, ALT bardaki yuvaya
     dokunulduğunda sorulan bir soru (bkz. AltBar.js). Bu sayfa artık yalnız
     doğrudan URL ile gelindiğinde hatırlanan tarafa düşer; başlığı da
     PageHeader yazar (Talep Gönder / Gelen Talepler). */

  const liste = taraf === "verdim" ? <GorevAtaPage /> : <GorevlerimPage />;

  /* FAZ-97 madde 8 — SEKME ARTIK TELEFONDA DA VAR.
     Kullanıcı: "Talepler'e tıklayınca açılan pencerede gelen talepler / giden
     talepler yazıyor ya, bundan birini seçince diğerine geçişi daha mantıklı,
     kolay şekilde yapamaz mıyız?"

     Teşhis: telefonda sayfanın İÇİNDE hiç seçici yoktu; taraf değiştirmek için
     alt bara inip menüyü açmak gerekiyordu — üç dokunuş. Tablet/masaüstünde
     bu sekme FAZ-91'den beri vardı.

     Alt bardaki soru KALIYOR (giriş noktası, kullanıcının kendi kararı);
     sayfadaki sekme GEÇİŞİ veriyor. İkisi çelişmiyor: biri "nereye gireyim",
     öteki "buradan öbürüne". */
  if (secilebilir) {
    return (
      <div className="talepler-kapi" data-katman={katmanAdi}>
        <div className="talepler-taraf-sekme" role="tablist" aria-label="Taraf">
          <button
            type="button"
            role="tab"
            aria-selected={taraf === "bana"}
            className={taraf === "bana" ? "etkin" : ""}
            onClick={() => setTaraf("bana")}
          >
            Bana Gelenler
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={taraf === "verdim"}
            className={taraf === "verdim" ? "etkin" : ""}
            onClick={() => setTaraf("verdim")}
          >
            Verdiklerim
          </button>
        </div>
        {liste}
      </div>
    );
  }

  return liste;
}
